import {
  useMediaEffect,
  MediaProps,
  MediaTemplateProps,
  MediaDefaultTemplate,
} from '../';

export const MediaElement = (props: MediaProps) => {
  const [state] = useMediaEffect(props);

  const templateProps: MediaTemplateProps = {
    type: props.type,
    source: props.source,
    alternative: props.alternative,
    width: props.width,
    height: props.height,
    ...state,
  };

  let template;
  switch (props.template) {
    case 'mediaDefault':
    default:
      template = MediaDefaultTemplate(templateProps);
      break;
  }

  return template;
};
